export default "__VITE_ASSET__DYdAP$JL__"